/* global axios */
import ApiClient from '../ApiClient';

class CaptainKnowledgeBaseAPI extends ApiClient {
  constructor() {
    super('captain/knowledge_bases', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  show({ id }) {
    return axios.get(`${this.url}/${id}`);
  }

  create({ payload }) {
    return axios.post(this.url, { knowledge_base: payload });
  }

  update({ id, payload }) {
    return axios.patch(`${this.url}/${id}`, { knowledge_base: payload });
  }

  delete({ id }) {
    return axios.delete(`${this.url}/${id}`);
  }

  documents({ id }) {
    return axios.get(`${this.url}/${id}/documents`);
  }

  assistants({ id }) {
    return axios.get(`${this.url}/${id}/assistants`);
  }

  // Per-assistant linking
  listForAssistant({ assistantId }) {
    return axios.get(
      `/api/v1/accounts/${this.accountId()}/captain/assistants/${assistantId}/knowledge_bases`
    );
  }

  link({ assistantId, knowledgeBaseId }) {
    return axios.post(
      `/api/v1/accounts/${this.accountId()}/captain/assistants/${assistantId}/knowledge_bases/link`,
      { knowledge_base_id: knowledgeBaseId }
    );
  }

  unlink({ assistantId, knowledgeBaseId }) {
    return axios.delete(
      `/api/v1/accounts/${this.accountId()}/captain/assistants/${assistantId}/knowledge_bases/${knowledgeBaseId}`
    );
  }

  accountId() {
    // Reuse the URL helper from ApiClient — strips off /api/v1/accounts/X/...
    const match = this.url.match(/accounts\/(\d+)/);
    return match ? match[1] : '';
  }
}

export default new CaptainKnowledgeBaseAPI();
